import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { savePaymentMethod } from "../Redux/Actions/cartActions";
import Header from "./../components/Header";
import {
  DEFAULT_CNC_ENABLED,
  DEFAULT_COD_ENABLED,
} from "../Redux/Constants/GlobalConstant";
import { DEFAULT_PAYMENT_PROVIDER } from "../config/Constant";
import BestDealSection from "../components/homeComponents/BestDealSection";

const PaymentScreen = ({ history }) => {
  // window.scrollTo(0, 0);

  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;
  const [isCOD, setIsCOD] = useState(DEFAULT_COD_ENABLED);
  const [isCNC] = useState(DEFAULT_CNC_ENABLED);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  if (!shippingAddress) {
    history.push("/shipping");
  }

  const [paymentProvider, setPaymentProvider] = useState(
    DEFAULT_PAYMENT_PROVIDER,
  );

  const dispatch = useDispatch();

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(savePaymentMethod(paymentProvider));
    history.push("/placeorder");
  };

  const paymentMethodHandler = (val) => {
    // console.log("selected payment Method: ", val);
    setPaymentProvider(val);
    // localStorage.setItem("selected_payment_method", val);
    
  };

  useEffect(() => {
    // console.log(userInfo);
    if (userInfo?.isVerified) {
      setIsCOD(true);
    }
  }, [userInfo]);
  return (
    <>
      <Header />
      <div className="container d-flex justify-content-center align-items-center login-center">
        <form
          className="Login2 col-md-8 col-lg-4 col-11"
          onSubmit={submitHandler}
        >
          <h6>SELECT PAYMENT METHOD</h6>
          <div className="payment-container">
            {/* Paypal and Cards */}
            {/* <div className="radio-container">
              <input
                className="form-check-input"
                type="radio"
                value={"paypal"}
                onChange={(e) => setPaymentProvider(e.target.value)}
                name="a"
                id="paypal"
                checked={paymentProvider === "paypal"}
              />
              <label htmlFor="paypal" className="form-check-label">
                Paypal / Cards
              </label>
            </div> */}

            {/* Stripe and Cards */}
            <div className="radio-container">
              <input
                className="form-check-input"
                type="radio"
                value={"stripe"}
                onChange={(e) => paymentMethodHandler(e.target.value)}
                name="a"
                id="stripe"
                checked={paymentProvider === "stripe"}
              />
              <label htmlFor="stripe" className="form-check-label">
                Online / Cards
              </label>
            </div>

            {/* UPI and all  */}
            {/* <div className="radio-container">
              <input
                className="form-check-input"
                type="radio"
                value={"upi"}
                onChange={(e) => setPaymentProvider(e.target.value)}
                name="a"
                id="aa"
                defaultChecked={paymentProvider === "upi"}
              />
              <label htmlFor="aa" className="form-check-label">
                UPI - Phonepe, G-pay
              </label>
            </div> */}

            {/* Paytm only */}
            {/* <div className="radio-container">
              <input
                className="form-check-input"
                type="radio"
                value={"UPI"}
                onChange={(e) => setPaymentProvider(e.target.value)}
                name="a"
                id="a"
              />
              <label htmlFor="a" className="form-check-label">
                Paytm
              </label>
            </div> */}

            {/* Cash on Delivery */}
            {isCOD && (
              <div className="radio-container">
                <input
                  className="form-check-input"
                  type="radio"
                  value={"cod"}
                  onChange={(e) => paymentMethodHandler(e.target.value)}
                  name="a"
                  id="c"
                />
                <label htmlFor="c" className="form-check-label">
                  Cash on Delivery
                </label>
              </div>
            )}
            {/* Click and Collect */}
            {isCNC && (
              <div className="radio-container">
                <input
                  className="form-check-input"
                  type="radio"
                  value={"cnc"}
                  onChange={(e) => paymentMethodHandler(e.target.value)}
                  name="a"
                  id="cnc"
                />
                <label htmlFor="cnc" className="form-check-label">
                  Click and Collect (CNC)
                </label>
              </div>
            )}
          </div>

          <button type="submit">Continue</button>
        </form>
      </div>
      <BestDealSection />
    </>
  );
};

export default PaymentScreen;
